{
  "CONFIRM_TYPE_OK_CANCEL": "OK_AND_CANCEL_CONFIRMATION",
  "ADD_EDIT_IMANAGE_CONNECTION": "ADD_EDIT_IMANAGE_CONNECTION"
}
